module.exports = __webpack_public_path__ + "static/img/Slice 19.04965cc7.png";